import { useCallback } from 'react';

const usePrintTemplate = (config) => {
	const createColumnData = useCallback(
		(arr) =>
			arr.map(({ name }) => {
				const colConfig = config.find((x) => x.name === name);
				const width = colConfig?.width && !isNaN(colConfig?.width) ? colConfig.width : 0;

				return {
					name,
					width
				};
			}),
		[config]
	);

	const getColumns = useCallback(
		(columnSettings) => {
			let columnNames;
			if (columnSettings?.length) {
				const shownColumns = columnSettings.filter((s) => s.show === true);
				columnNames = createColumnData(shownColumns);
			} else {
				columnNames = createColumnData(
					config
						.filter((x) => x?.show)
						.map((c) => ({
							name: c.name
						}))
				);
			}

			const remainedColumnsWidth = columnNames.reduce((acc, curr) => {
				const currNum = curr?.width && !isNaN(curr.width) ? curr.width : 0;
				return acc - currNum;
			}, 100);

			const addPerShow = Math.round(remainedColumnsWidth / columnNames.length);

			columnNames.forEach((c) => {
				c.width += addPerShow;
			});

			// create custom render for each column
			columnNames = columnNames.map((c) => {
				const colConfig = config.find((x) => x.name === c.name);

				return {
					...c,
					renderCell: colConfig?.renderCell ?? 'text',
					accessor: colConfig?.accessor ?? c.name
				};
			});
			return columnNames;
		},
		[config]
	);

	const getRows = useCallback((items, columnSettings) => {
		const columns = getColumns(columnSettings);
		if (columns.length && items.length) {
			return items.map((item) => {
				const obj = {};
				columns.forEach((col) => {
					obj[col.accessor] = item[col.accessor] || !isNaN(item[col.accessor]) ? item[col.accessor] : '';
				});
				return obj;
			});
		}
		return [];
	}, []);

	return { getColumns, getRows };
};

export default usePrintTemplate;
